// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"93e282cc","160":"14e8c284","208":"016d116f","293":"0e9decc0","516":"0edcec23","519":"4283eddb","917":"f296873c","946":"e8ec5c9d"}[chunkId] + ".chunk.js";
};